export default __webpack_public_path__ + "fa2b47d5ced947b82aebaff1cfc9a38f.glb";